import {inject, observer} from "mobx-react";

import Const from "@const";
import PageUtils from "@utils/PageUtils";
import Path from "../../router/path";
import React from 'react';
import {removeAppLoading} from "@utils/ComUtils";

@inject('appState')
@observer
export default class AppIni extends React.Component {

  componentDidMount() {
    this.init();
  }

  async init() {
    if (Const.DO_NOT_GET_USER_INFO_WITH_LIST.indexOf(PageUtils.currentPath()) === -1) {
      // 获取用户信息
      await this.props.appState.getUserInfo();

    }
    this.props.appState.setAppLoaded(true);

    if (!PageUtils.pathEqual(Path.CASTER)) {
      removeAppLoading();
    }
    
  }

  render() {
    return '';
  }

}
